import type { Space } from '../@types/styles'

export function spaceToCustomProperty(value: Space) {
    return `var(--space-${value})`
}
